function toggleFilter() {
  let button = $('.teachers-page__label');
  let container = $('.teachers-page__container');
  let toggle = $('.teachers-page__toggle');
  for (let i = 0; i < Array.from(button).length; i++) {
    $(button[i]).on('click', function () {
      let id = button[i].getAttribute('data-id');
      let goTo = button[i].getAttribute('goto');
      button.removeClass('active');
      $(this).addClass('active');
      if (id == 1) {
        button.removeClass('active');
        container.removeClass('active');
        $('.teachers-page__label[data-id="1"]').remove();
        $('.teachers-page__container[data-id="1"]').remove();

        $('.teachers-page__label[data-id="2"]').addClass('active');
        $('.teachers-page__container[data-id="2"]').addClass('active');
      }
      if (goTo == 3) {
        button.removeClass('active');
        container.removeClass('active');
        $('.teachers-page__label[data-id="3"]').addClass('active');
        $('.teachers-page__container[data-id="3"]').addClass('active');
      }
      if (goTo == 2) {
        button.removeClass('active');
        container.removeClass('active');
        $('.teachers-page__label[data-id="2"]').addClass('active');
        $('.teachers-page__container[data-id="2"]').addClass('active');
      }
    });
  }
  toggle.on('click', function() {
    $(this).toggleClass('active');
  });
}
toggleFilter();